<script lang="ts" setup>
const { t } = useI18n()

const { urls } = useAppConfig()
</script>

<template>
  <HomeHero
    :description="t('description')"
    even
    orientation="horizontal"
    :title="t('title')"
    :ui="{
      title: 'text-2xl sm:text-3xl md:text-5xl',
    }"
  >
    <template #headline>
      <UButton
        class="rounded-full"
        color="indigo"
        :label="t('latestUpdates')"
        size="xs"
        :to="urls.updates"
        :trailing-icon="getIcon('arrowRight')"
        variant="subtle"
      />
    </template>

    <template #default>
      <div class="flex w-full flex-col gap-4">
        <SectionCompanyProfile />
      </div>
    </template>

    <template #links>
      <SectionGetStartedButtons />
    </template>
  </HomeHero>
</template>

<i18n lang="json">
{
  "en": {
    "description": "Enrich companies in a single API call with 300+ data points. Take advantage of our database and build the features your users need.",
    "latestUpdates": "Discover our latest updates",
    "title": "Turn a domain name into a company profile"
  },
  "es": {
    "description": "Enriquece empresas en una sola llamada a la API con más de 300 puntos de datos. Aprovecha nuestra base de datos y crea las funciones que tus usuarios necesitan.",
    "latestUpdates": "Descubre nuestras últimas actualizaciones",
    "title": "Convierte un nombre de dominio en un perfil de empresa"
  },
  "fr": {
    "description": "Enrichissez des entreprises en un seul appel API avec plus de 300 points de données. Profitez de notre base de données et créez les fonctionnalités dont vos utilisateurs ont besoin.",
    "latestUpdates": "Découvrez nos dernières mises à jour",
    "title": "Transformez un nom de domaine en un profil d'entreprise"
  }
}
</i18n>
